import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import TimelineScorecard from '../TimelineScorecard.vue'
import { Timesheets } from '../../types/timers'
import { computed, ref } from 'vue'
import BaseModal from '../wrappers/BaseModal.vue'
import FilteringDataDisplay from '../FilteringDataDisplay.vue'
import { useExpenses, formatExpensesForTable } from '../../store/useExpenses'
import { Table } from '../../types/components/data-rendering'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviousActivitiesScorecardExpenses',
  props: {
    timesheets: {}
  },
  setup(__props: any) {

const props = __props

//translations
const { t } = useI18n({ useScope: 'global' })
const label = (key: string) => t(`payPeriod.${key}`)
const form = (key: string) => t(`form.${key}`)

const totalExpenses = computed(() => {
  return props.timesheets
    .reduce((acc, timesheet) => {
      return acc + timesheet.expenses
    }, 0)
    .toLocaleString(undefined, { style: 'currency', currency: 'USD' })
})
const { getExpensesByDateRange } = useExpenses()
const expenses = computed((): Table => {
  if (!props.timesheets.length) return { meta: {}, data: [] }
  const start = new Date(props.timesheets[props.timesheets.length - 1].date)
  const end = new Date(props.timesheets[0].date)
  //needs to be end of the day, otherwise potential current day is excluded
  end.setHours(23)
  end.setMinutes(59)
  const data = getExpensesByDateRange({ start, end })
  return formatExpensesForTable(data)
})

const value = ref(false)

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TimelineScorecard, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (value.value = true)),
      header: label('expenses'),
      subheader: totalExpenses.value
    }, null, 8, ["header", "subheader"]),
    _createVNode(BaseModal, {
      modelValue: value.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(`${form('total')} ${label('expenses')}: ${totalExpenses.value}`), 1)
      ]),
      content: _withCtx(() => [
        _createVNode(FilteringDataDisplay, {
          "table-data": expenses.value,
          "enable-filters": false
        }, null, 8, ["table-data"])
      ]),
      actions: _withCtx(() => [
        _withDirectives(_createVNode(_component_q_btn, {
          rounded: "",
          flat: "",
          label: form('close')
        }, null, 8, ["label"]), [
          [_directive_close_popup]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})